import React from "react";
import PageHeader from "../../../components/ui/page header/PageHeader";
import { useTranslation } from "react-i18next";
import ProductsSection from "./components/productsSection/ProductsSection";

function ProductsPage() {
  const { t } = useTranslation("products");

  return<>
    <PageHeader
      topic={t("pageHeader.topic")}
      topicSentence={t("pageHeader.topicSentence")}
    />
    <ProductsSection/>
  </>;
}

export default ProductsPage;
